import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getAppointments = catchAsync(
  (location: string | number, params: object) => {
    return axiosInstance.get(`salon/${location}/appointments`, {
      params,
    });
  }
);
export const getAppointment = catchAsync((location: any, appointment: any) => {
  return axiosInstance.get(`salon/${location}/appointments/${appointment}`);
});

export const cancelAppointment = catchAsync(
  (locationId: number, appointmentId: number, reason: string | null) => {
    return axiosInstance.post(
      `salon/${locationId}/appointments/${appointmentId}/cancel`,
      { cancellation_reason_id: reason }
    );
  }
);
export const updateAppointment = catchAsync(
  (locationId: number, appointmentId: number, body: {}) => {
    return axiosInstance.put(
      `salon/${locationId}/appointments/${appointmentId}`,
      body
    );
  }
);

export const getCancelReasons = catchAsync(() => {
  return axiosInstance.get(`salon/cancellation-reasons`);
});

export const getAvailableLoyaltyDiscounts = catchAsync(
  (locationId: number, clientId: number) => {
    return axiosInstance.get(
      `salon/loyalty-ranges?location_id=${locationId}&client_id=${clientId}`
    );
  }
);
